'use strict';

/*
 * Associates locations with their respective teams
 * Array elements are created in a new array depending on each team member's associatedOffice
 * value. Team members with identical values are placed within a new array at
 * that office's index, leaving some undefined indices. Array of arrays is returned.
 */
export function mapTeamMembersToOffices(offices = [], teamMembers = []) {
    const sortedOffices = [];

    for (const member of teamMembers) {
        let officeNumber = parseInt(member.associatedOffice.replace('office_', ''), 10);
        officeNumber = officeNumber < offices.length ? officeNumber : 0;

        if (!sortedOffices[officeNumber]) {
            sortedOffices[officeNumber] = [];
        }

        sortedOffices[officeNumber].push(member);
    }

    return sortedOffices;
}



// WEBPACK FOOTER //
// ./components/team_members/selectors.js